import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Form, Breadcrumb, Card } from 'react-bootstrap';
import axios from "axios";
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import moment from "moment";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { useNavigate } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Avatar } from 'primereact/avatar';
import nouserpng from '../../assets/images/no_user.png';
import successVideo from '../../assets/video/paperplane.mp4';
import BoardSidebar from '../kanbanBoard/BoardSidebar';
import CustomToast from '../../components/CustomToast';
import { getSocket } from '../../context/socket'; // adjust path as needed
import { buildUserOptions } from '../../utils/userOptions';
const AddProjects = () => {
    const { accessToken } = useAuth(); // Get the access token from the context
    const [loading, setLoading] = useState(false);
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const socket = getSocket();
    const navigate = useNavigate(); // React Router's navigate hook
    const [brands, setBrands] = useState([]);
    const [users, setUsers] = useState([]);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [projectData, setProjectData] = useState({
        project_name: "",
        brand_id: "",
        start_date: "",
        end_date: "",
        description: "",
        priority: "Medium",
        lead_id: "",
        member_id: [],
        project_files: "",
    });
    const [newBrand, setNewBrand] = useState("");
    const [showAddBrand, setShowAddBrand] = useState(false);
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
    });

    const toastRef = useRef(null);

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };


    const [selectedBoard, setSelectedBoard] = useState(null);
    const [newBoardName, setNewBoardName] = useState('');
    const [isCreatingNew, setIsCreatingNew] = useState(false);

    // Sample boards list (can be replaced with API data)
    const [boards, setBoards] = useState([]);


    useEffect(() => {
        const socket = getSocket();

        if (!socket) {
            console.log("❌ Socket not connected yet");
            return;
        }
    }, []);




    const handleViewBoard = () => {
        if (isCreatingNew && newBoardName.trim() !== '') {
            setKanbanVisible(true);
        } else if (!isCreatingNew && selectedBoard) {
            const selected = boards.find(board => board.value === selectedBoard);
            if (selected) {
                // 🔧 FIX: Sort the lists by position before setting them
                const sortedLists = [...selected.lists].sort((a, b) => a.position - b.position);

                setCustomColumns(
                    sortedLists.map(list => ({
                        name: list.name,
                        color: list.color_code
                    }))
                );
                setNewBoardName(selected.label);
                setKanbanVisible(true);
            }
        }
    };


    const [customColumns, setCustomColumns] = useState([
        { name: '', color: '#cccccc' }
    ]);

    const addCustomColumn = () => {
        const updated = [...customColumns];
        const completedIndex = updated.findIndex(col => col.name === 'Completed');

        if (completedIndex === -1) {
            // If somehow 'Completed' is not found, just add at the end (fallback)
            updated.push({ name: '', color: '#cccccc' });
        } else {
            updated.splice(completedIndex, 0, { name: '', color: '#cccccc' });
        }

        setCustomColumns(updated);
    };


    const removeCustomColumn = (index) => {
        if (customColumns[index].name === 'To Do' || customColumns[index].name === 'Completed') {
            // Prevent deleting static columns
            return;
        }
        const updated = [...customColumns];
        updated.splice(index, 1);
        setCustomColumns(updated);
    };


    const updateCustomColumn = (index, updatedColumn) => {
        const updated = [...customColumns];
        updated[index] = updatedColumn;
        setCustomColumns(updated);
    };

    const [kanbanVisible, setKanbanVisible] = useState(false);


    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/TemplateBoardRoutes/fetch-all-templates`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const templates = response.data;

                const boardOptions = templates.map(template => ({
                    label: template.template_name,
                    value: template.board_template_id,
                    description: template.description,
                    lists: template.lists // store the predesigned columns too
                }));

                setBoards(boardOptions);
            } catch (error) {
                console.error('Error fetching board templates:', error);
            }
        };

        fetchTemplates();
    }, [accessToken]);




    // Fetch all users and brands
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetch-all-users`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setUsers(data);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        const fetchBrands = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetchallbrands`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setBrands(data);
            } catch (error) {
                console.error("Error fetching brands:", error);
            }
        };

        fetchUsers();
        fetchBrands();
    }, [accessToken]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProjectData((prev) => ({ ...prev, [name]: value }));
    };

    const setProjectField = (name, value) => {
        setProjectData((prev) => ({ ...prev, [name]: value }));
    };

    const userOptions = buildUserOptions(users);

    const handleDateRangeChange = (start, end) => {
        setDateRange({ startDate: start, endDate: end });
        setProjectData({
            ...projectData,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
        });
    };

    const handleAddBrand = async () => {
        if (!newBrand.trim()) return;
        try {
            const { data } = await axios.post(
                `${config.apiBASEURL}/projectRoutes/AddeditBrands`,
                { brand_name: newBrand },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            setBrands((prevBrands) => [...prevBrands, data]);
            setProjectData((prevData) => ({ ...prevData, brand_id: data.brand_id }));
            setNewBrand("");
            setShowAddBrand(false);
        } catch (error) {
            console.error("Error adding new brand:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Convert your custom columns into the required list structure
        const formattedLists = customColumns.map((col, index) => ({
            name: col.name,
            position: index,
            color_code: col.color,
        }));

        const payload = {
            ...projectData,
            Board_name: newBoardName,
            lists: formattedLists,
        };

        if (
            !projectData.project_name ||
            !projectData.brand_id ||
            !projectData.lead_id ||
            projectData.member_id.length === 0 ||
            !newBoardName
        ) {
            showMessage('error', 'Please fill all required fields.');
            return;
        }

        if (formattedLists.length < 3) {
            showMessage('error', 'Please add at least 3 columns to the board.');
            return;
        }

        setLoading(true);

        // Clean previous listeners
        socket.off('project-added-success');
        socket.off('project-added-error');

        // Handle success
        socket.once('project-added-success', (res) => {
            showMessage('success', res.message);
            setVideoDialogVisible(true);

            setTimeout(() => {
                setVideoDialogVisible(false);
                navigate("/Graphe/dashboard/all_projects");
            }, 3000);

            setLoading(false);
        });

        // Handle error
        socket.once('project-added-error', (err) => {
            console.error("Error creating project:", err.message);
            showMessage('error', err.message);
            setLoading(false);
        });

        // Emit to server
        socket.emit('add-project', {
            project_name: projectData.project_name,
            brand_id: projectData.brand_id,
            start_date: projectData.start_date,
            end_date: projectData.end_date,
            description: projectData.description,
            priority: projectData.priority,
            lead_id: projectData.lead_id,
            project_files: projectData.project_files,
            member_id: projectData.member_id,
            lists: formattedLists
        });
    };


    const headerElement = (
        <div className="d-flex align-items-center justify-content-center gap-2">
            <Avatar image={nouserpng} size="large" shape="circle" title="User Avatar" />
            <span className="font-bold white-space-nowrap h6">System Message</span>
        </div>
    );

    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={12} lg={12} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                <i className="pi pi-angle-left"></i> Back
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Add Projects</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={12} lg={9} >
                        <Card>
                            <Card.Body>
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6} lg={6} className="px-2 mb-3">
                                            <label className="mb-2">Project Name</label>
                                            <InputText
                                                name="project_name"
                                                value={projectData.project_name}
                                                onChange={handleChange}
                                                required
                                                placeholder="Enter project name"
                                                className="w-full"
                                            />
                                        </Col>
                                        <Col md={6} lg={6} className="px-2 mb-3">
                                            <label className="d-flex align-items-center justify-content-between mb-2">
                                                Brand
                                                <span>
                                                    {!showAddBrand && (
                                                        <Button
                                                            severity="danger"
                                                            outlined
                                                            onClick={() => setShowAddBrand(true)}
                                                            label="Add Brand"
                                                            icon="pi pi-plus"
                                                            className="border-0 p-0"
                                                        />
                                                    )}
                                                </span>
                                            </label>
                                            <div className="position-relative">
                                                <div className="w-100">
                                                    <Dropdown
                                                        name="brand_id"
                                                        value={projectData.brand_id}
                                                        options={brands.map((brand) => ({
                                                            label: brand.brand_name,
                                                            value: brand.brand_id,
                                                        }))}
                                                        onChange={(e) => setProjectField('brand_id', e.value)}
                                                        placeholder="Select a brand"
                                                        className="w-full"
                                                    />
                                                </div>
                                                <div className="add_BRAND">
                                                    {showAddBrand && (
                                                        <div className="mt-2 d-flex align-items-center border pe-2">
                                                            <InputText
                                                                value={newBrand}
                                                                onChange={(e) => setNewBrand(e.target.value)}
                                                                placeholder="Enter new brand name"
                                                                className="w-full border-0"
                                                            />
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    severity="success"
                                                                    onClick={handleAddBrand}
                                                                    title="Save"
                                                                    icon="pi pi-check"
                                                                    className="p-0"
                                                                />
                                                                <Button
                                                                    severity="danger"
                                                                    onClick={() => setShowAddBrand(false)}
                                                                    title="Cancel"
                                                                    icon="pi pi-times"
                                                                    className="p-0"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={4} className="px-2 mb-3">
                                            <label className="mb-2">Date Range</label>
                                            <DateRangePicker
                                                initialSettings={{
                                                    startDate: dateRange.startDate,
                                                    endDate: dateRange.endDate,
                                                    locale: { format: "DD/MM/YYYY" },

                                                }}
                                                onCallback={(start, end) => handleDateRangeChange(start, end)}
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control w-full"
                                                    placeholder="Select Date Range"
                                                />
                                            </DateRangePicker>
                                        </Col>

                                        <Col md={6} lg={4} className="px-2 mb-3">
                                            <label className="mb-2">Project Lead</label>
                                            <Dropdown
                                                name="lead_id"
                                                value={projectData.lead_id}
                                                options={userOptions}
                                                onChange={(e) => setProjectField('lead_id', e.value)}
                                                placeholder="Select a project lead"
                                                className="w-full"
                                            />
                                        </Col>

                                        <Col md={6} lg={4} className="px-2 mb-3">
                                            <label className="mb-2">Priority</label>
                                            <Dropdown
                                                name="priority"
                                                value={projectData.priority}
                                                options={[
                                                    { label: "Low", value: "Low" },
                                                    { label: "Medium", value: "Medium" },
                                                    { label: "High", value: "High" },
                                                ]}
                                                onChange={(e) => setProjectField('priority', e.value)}
                                                placeholder="Select priority"
                                                className="w-full"
                                            />
                                        </Col>

                                        <Col md={6} lg={6} className="px-2 mb-3">
                                            <label className="mb-2">Add Team Members</label>
                                            <MultiSelect
                                                value={projectData.member_id}
                                                options={userOptions}
                                                onChange={(e) =>
                                                    setProjectField('member_id', e.value || [])
                                                }
                                                placeholder="Select team members"
                                                className="w-full position-relative"
                                                display="chip"
                                            />
                                        </Col>
                                        <Col md={6} lg={6} className="px-2 mb-3">
                                            <label className="mb-2">Project Files (URL)</label>
                                            <InputTextarea
                                                rows={2}
                                                name="project_files"
                                                value={projectData.project_files}
                                                onChange={handleChange}
                                                placeholder="Enter a link or URL for project files"
                                                className="w-full"
                                            />
                                        </Col>
                                        <Col md={6} lg={12} className="px-2 mb-3">
                                            <label className="mb-2">Description</label>
                                            <InputTextarea
                                                rows={4}
                                                name="description"
                                                value={projectData.description}
                                                onChange={handleChange}
                                                placeholder="Enter description"
                                                className="w-full h-auto"
                                            />
                                        </Col>
                                        <Col md={12} lg={12} className="px-2 mb-3 text-end">
                                            <Button
                                                severity="info"
                                                type="submit"
                                                label={loading ? "Saving..." : "Add Project"}
                                                icon="pi pi-save"
                                                className="py-2"
                                                loading={loading}
                                                disabled={loading}
                                            />
                                        </Col>
                                    </Row>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={12} lg={3}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col md={12} lg={12} className='mb-3'>
                                        <h6 className="mb-2">Select or Create Project Board</h6>
                                    </Col>

                                    <Col md={12} lg={12} className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="d-flex w-100 gap-2">
                                                <Button
                                                    label="Existing"
                                                    className={`w-50 py-2 ${!isCreatingNew ? 'p-button-primary' : 'p-button-outlined'}`}
                                                    severity="warning"
                                                    onClick={() => {
                                                        setIsCreatingNew(false);
                                                        setNewBoardName('');
                                                        setSelectedBoard(null);
                                                        setCustomColumns([]);
                                                    }}
                                                />
                                                <Button
                                                    label="New"
                                                    className={`w-50 py-2 ${isCreatingNew ? 'p-button-primary' : 'p-button-outlined'}`}
                                                    severity="primary"
                                                    outlined
                                                    onClick={() => {
                                                        setIsCreatingNew(true);
                                                        setNewBoardName('Custom Board');
                                                        setSelectedBoard(null);
                                                        setCustomColumns([
                                                            { name: 'To Do', color: '#1976D2' },
                                                            { name: '', color: '#cccccc' }, // empty first custom column
                                                            { name: 'Completed', color: '#43A047' }
                                                        ]);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {isCreatingNew ? (
                                            <>
                                                <InputText
                                                    value={newBoardName}
                                                    onChange={(e) => setNewBoardName(e.target.value)}
                                                    placeholder="Enter new board name"
                                                    className="w-100 mb-3"
                                                    required
                                                />

                                                <div className="mb-2">
                                                    <h6 className="mb-4 pt-2">Board Columns</h6>

                                                    {customColumns.map((col, index) => (
                                                        <div className="d-flex align-items-center mb-2 position-relative" key={index}>
                                                            <span className="me-2" style={{ width: '30px' }}>{index + 1}.</span>

                                                            <InputText
                                                                value={col.name}
                                                                onChange={(e) => updateCustomColumn(index, { ...col, name: e.target.value })}
                                                                className="w-100 me-2"
                                                                disabled={col.name === 'To Do' || col.name === 'Completed'}
                                                                placeholder="Enter column name"
                                                            />

                                                            <input
                                                                type="color"
                                                                value={col.color || '#cccccc'}
                                                                onChange={(e) => updateCustomColumn(index, { ...col, color: e.target.value })}
                                                                style={{ width: '70px', height: '46px', border: '0', background: 'none' }}
                                                                className="me-2 border-0"
                                                                disabled={col.name === 'To Do' || col.name === 'Completed'}
                                                            />

                                                            {/* Only show delete button if NOT 'To Do' or 'Completed' */}
                                                            {col.name !== 'To Do' && col.name !== 'Completed' && (
                                                                <Button
                                                                    icon="pi pi-times"
                                                                    className="p-button-text p-button-danger p-button-sm"
                                                                    onClick={() => removeCustomColumn(index)}
                                                                    style={{ position: 'absolute', right: '-26px', top: '-3px' }}
                                                                />
                                                            )}
                                                        </div>
                                                    ))}
                                                    <div className="d-flex justify-content-end">
                                                        {/* Add column button */}
                                                        <Button
                                                            label="Add"
                                                            icon="pi pi-plus"
                                                            className="py-1 px-3 mt-2"
                                                            onClick={addCustomColumn}
                                                            outlined
                                                            severity="secondary"
                                                        />
                                                    </div>


                                                </div>
                                            </>


                                        ) : (
                                            <Dropdown
                                                value={selectedBoard}
                                                options={boards}
                                                onChange={(e) => {
                                                    setSelectedBoard(e.value);
                                                    const selected = boards.find(board => board.value === e.value);
                                                    if (selected) {
                                                        setNewBoardName(selected.label); // Set the board name
                                                    }
                                                }}
                                                placeholder="Select a board"
                                                className="w-100"
                                            />
                                        )}
                                    </Col>

                                    <Col md={12} lg={12} className="text-center">
                                        <Button
                                            label="View Board"
                                            className="border-0 d-block w-100"
                                            onClick={handleViewBoard}
                                            disabled={isCreatingNew ? !newBoardName.trim() : !selectedBoard}
                                            severity="help"
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
            <CustomToast ref={toastRef} />
            {/* Dialog */}
            {/* <Dialog
                visible={isDialogVisible}
                onHide={() => setIsDialogVisible(false)}
                header={headerElement}
                style={{ width: '350px' }}
                modal
                footer={
                    <div className="d-flex justify-content-end ">
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            outlined
                            severity="success"
                            className="border-0 me-2 py-0"
                            onClick={handleNavigateToAddTask}
                        />
                        <Button
                            label="No"
                            icon="pi pi-times"
                            outlined
                            severity="danger"
                            className="border-0 ms-2 py-0"
                            onClick={handleNavigateToProjectList}
                        />
                    </div>
                }
            >
                <p className="mb-0">Do you want to <b>Add Tasks</b> to this project?</p>

            </Dialog> */}

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>

            <BoardSidebar
                visible={kanbanVisible}
                onHide={() => setKanbanVisible(false)}
                customColumns={customColumns}
                boardName={newBoardName}
            />
        </>
    );
};

export default AddProjects;
